export default {"src":"/_next/static/media/enerflo-platform-icon-best-in-class-support.4029be0f.svg","height":160,"width":160};